import { ASPECT_RATIO, type AspectRatioType } from '../../config';
import { MaterialForm } from '../../types';

export const getAspectRatio = ({
  materialForm,
  isPortrait,
}: {
  materialForm: MaterialForm;
  isPortrait: boolean;
}): AspectRatioType => {
  if (materialForm === MaterialForm.loose) {
    return ASPECT_RATIO.SQUARE;
  }
  if (materialForm === MaterialForm.baled || materialForm === MaterialForm.briquette) {
    return isPortrait ? ASPECT_RATIO.PORTRAIT : ASPECT_RATIO.LANDSCAPE;
  }
  return ASPECT_RATIO.SQUARE;
};

export const captureImage = ({ video }: { video: HTMLVideoElement }): Promise<File | null> => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');

    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      canvas?.toBlob((blob) => {
        if (blob) {
          resolve(new File([blob], 'photo.jpg', { type: 'image/jpeg' }));
        } else {
          resolve(null);
        }
      }, 'image/jpeg');
    } else {
      resolve(null);
    }
  });
};
